import axios from 'axios';

import authModel from '../models/auth';

import {doLogout} from './login';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const conn=()=>{

  const auth=authModel();
  const headers={
    'Content-Type':'application/json'
  }
  if(auth.token) {
    headers.Authorization=auth.token;
  }
  const instance = axios.create({
    baseURL: BASE_URL,
    headers
  });


  instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error


    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      const status=error.response.status;
      if(status === 401) {
        doLogout();
        window.location.href="/";
      }
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Undetected Error!', error.message);
    }
    return Promise.reject(error);
  });



  return instance;
}

// const parseConnError=(e)=>{

// }

export {
  conn
}